import {
  getAllSalesOrder,
  getPatientAdvPayments,
  getPatientInvoices,
} from "./ERPActions/erpActions";

import {
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS,
  ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS,
  MONTH_SHORT_NAME,
  PAGE_MODE,
  INVOICE_DETAILS_LABEL,
} from "../../core/constants/erpConstants";

import { helperServices } from "../../shared/helper";

export const isFullInvoiceNumber = (value) =>
  /^[A-Za-z]{2,5}\d+-\d+\/\d+$/.test((value || "").trim());

export const fetchInvoices = async ({
  patientId,
  visitId,
  locationId,
  fromDate,
  toDate,
  searchQuery,
  clientERPCustId,
  totlAdvancePaid,
  props,
  masterLocationDetails,
  org,
}) => {
  try {
    // if (locationId && locationId.length > 0) {
    let finalRowData = [];
    let updateTotalBillAmount = 0;
    let updateTotalCreditedAmount = 0;
    let totalFinancialSummary = {
      all: {
        totalReceivedAmount: 0,
        totalBillAmount: 0,
        totalDiscountAmount: 0,
        totalGrossAmount: 0,
        invReceivedAmt: 0,
        invPendingPaymentAmt: 0,
        totalSalesOrderAmt: 0,
        totalReceivedAdvanceAmt: 0,
        creditBalance: 0,
        totalRoundOffAmt: 0,
        creditInvoiceCount: 0,
      },
    };
    // 1. Invoices
    const isInvoiceNumber = isFullInvoiceNumber(searchQuery);

    let invoiceCount = 0;
    let payload = {
      patientId: patientId,
      visitId: visitId,
      locationIds: locationId,
      fromDate: fromDate,
      toDate: toDate,
      ticketIds: null,
      searchQuery: !isInvoiceNumber ? searchQuery : null,
      billNumber: isInvoiceNumber ? searchQuery : null,
      erpCustId: clientERPCustId,
    };

    const patientInvcResp = await getPatientInvoices(payload);
    console.log("get invoices response : ", patientInvcResp);
    if (patientInvcResp) {
      console.log(
        "fetchInvoices : response : ",
        patientInvcResp,
        totlAdvancePaid,
        updateTotalBillAmount,
      );
      const invoiceListResp = getAllRowDataInvoice(
        patientInvcResp.invoiceDetailInfo,
        totalFinancialSummary,
        masterLocationDetails,
      );
      totalFinancialSummary = { ...invoiceListResp.finSummary };
      finalRowData = [...invoiceListResp.rowData];
      invoiceCount = finalRowData.length;
    }

    if (props.pageMode == PAGE_MODE.SINGLE_INVOICE || !props.pageMode) {
      const salesOrderResp = await getAllSalesOrder(
        patientId,
        visitId,
        locationId,
      );
      if (salesOrderResp) {
        console.log("getAllSalesOrder : response : ", salesOrderResp);
        const salesFinResp = getAllRowDataSaleOrders(
          salesOrderResp.soWLineList,
          finalRowData,
          totalFinancialSummary,
          masterLocationDetails,
        );
        totalFinancialSummary = { ...salesFinResp.finSummary };
      }
    }
    const patientPaymentsResp = await getPatientAdvPayments(
      patientId,
      visitId,
      locationId,
      fromDate,
      toDate,
      searchQuery,
    );
    console.log("Advance payments:", patientPaymentsResp);
    if (patientPaymentsResp) {
      if (
        patientPaymentsResp.erpResp &&
        patientPaymentsResp.erpResp.respStatus == 0
      ) {
        const payemtRowResp = getAllPatientPayments(
          patientPaymentsResp.erpResp.customerPaymentInfo,
          finalRowData,
          totalFinancialSummary,
          masterLocationDetails,
          org,
        );
        totalFinancialSummary = payemtRowResp.finSummary;
        finalRowData = payemtRowResp.rowData;
      }
    }
    totalFinancialSummary["all"].totalInvoiceCount = invoiceCount;
    return {
      rowData: finalRowData,
      finSummary: totalFinancialSummary,
      invoiceCount: invoiceCount,
    };
  } catch (error) {
    console.error("Error fetching Invoices :", error);
  }
};

function getAllRowDataInvoice(
  invDetailInfo,
  finInvSummary,
  masterLocationDetails,
) {
  let uRowData = [];
  let calculatedTotalBillAmt = 0;
  let calculatedTotalAdvPaid = 0; // Create a local variable to track total advance paid
  let calculatedTotalDiscountAmount = 0; // Create a local variable to track total discount paid
  let calculatedTotalGrossAmount = 0; // Create a local variable to track total discount paid
  let calTotalInvPendingPaymentAmt = 0;
  let calTotalRoundOffAmt = 0;
  if (!finInvSummary) finInvSummary = {};
  if (!finInvSummary.all) {
    finInvSummary.all = {
      totalReceivedAmount: 0,
      totalDiscountAmount: 0,
      totalGrossAmount: 0,
      totalBillAmount: 0,
      invReceivedAmt: 0,
      invPendingPaymentAmt: 0,
      totalSalesOrderAmt: 0,
      totalReceivedAdvanceAmt: 0,
      creditBalance: 0,
      totalRoundOffAmt: 0,
      creditInvoiceCount: 0,
    };
  }
  if (invDetailInfo != null) {
    invDetailInfo.forEach((invoice) => {
      try {
        const date = new Date(invoice.invoiceDate);
        let invDate = `${date.getDate()} ${
          MONTH_SHORT_NAME[date.getMonth()]
        } ${date.getFullYear()}`;
        let paymentAmount = 0;
        let disocuntAmount = 0;
        let billAmt = 0;
        let invLocationId = invoice.locationId;

        if (!(invLocationId in finInvSummary)) {
          finInvSummary[invLocationId] = {
            totalReceivedAmount: 0,
            totalBillAmount: 0,
            totalDiscountAmount: 0,
            totalGrossAmount: 0,
            invReceivedAmt: 0,
            invPendingPaymentAmt: 0,
            totalSalesOrderAmt: 0,
            totalReceivedAdvanceAmt: 0,
            creditBalance: 0,
            totalRoundOffAmt: 0,
          };
        }
        let discountAmount = 0;
        const roundOff = Number(invoice.roundOff) || 0;
        if (invoice.invoiceLineItem != null) {
          billAmt = invoice.invoiceAmount;
          paymentAmount = invoice.balanceAmount; //billAmt - invoice.receivedAmount;
          calculatedTotalAdvPaid += invoice.receivedAmount;

          // (invoice.originalPriceSell - (invoice.unitPriceIncTax/(1+invoice.taxRate)));
          // calculatedTotalDiscountAmount +=invoice.discountAmount;
          calculatedTotalBillAmt += billAmt;
          calTotalInvPendingPaymentAmt += invoice.balanceAmount;
          calTotalRoundOffAmt += roundOff;
          invoice.invoiceLineItem.forEach((item) => {
            discountAmount +=
              (item.originalPriceSell -
                item.unitPriceIncTax / (1 + item.taxRate)) *
              item.units;
            calculatedTotalGrossAmount += item.originalPriceSell * item.units;
            finInvSummary[invLocationId].totalGrossAmount +=
              item.originalPriceSell * item.units;
          });
          calculatedTotalDiscountAmount += discountAmount;
        }
        // Accumulate for location

        finInvSummary[invLocationId].totalReceivedAmount +=
          invoice.receivedAmount;
        finInvSummary[invLocationId].totalDiscountAmount += discountAmount;
        finInvSummary[invLocationId].totalRoundOffAmt += roundOff;
        // invoice.discountAmount;

        finInvSummary[invLocationId].totalBillAmount += invoice.invoiceAmount;
        finInvSummary[invLocationId].invReceivedAmt += invoice.receivedAmount;
        finInvSummary[invLocationId].invPendingPaymentAmt +=
          invoice.balanceAmount;
        if (!invoice.isKpCash) {
          finInvSummary.all.creditInvoiceCount += 1;
        }
        // Row
        let row = {
          invoiceId: invoice.billNumber,
          ticketId: invoice.ticketId,
          patientId: invoice?.patientERPObj?.id,
          visitId: invoice?.patientERPObj?.visitId,
          generatedBy: invoice?.generatedBy || "",
          patientFullName: helperServices.getFullName(
            invoice?.patientERPObj?.fname,
            invoice?.patientERPObj?.mname,
            invoice?.patientERPObj?.lname,
          ),
          ipopnumber: invoice?.patientERPObj?.ipopnumber,
          soId: invoice.ticketId,
          type: ERP_VISIT_FIN_SUMMARY_TYPE_INV,
          invoiceDate: invDate,
          billAmt: `₹ ${billAmt}`,
          receivedAmt: `₹ ${
            invoice.receivedAmount ? invoice.receivedAmount.toFixed(2) : 0
          }`,
          paymentAmt: `₹ ${paymentAmount ? paymentAmount.toFixed(2) : 0}`,
          discountAmt: `₹ ${
            invoice.discountAmount ? discountAmount.toFixed(2) : 0
          }`,
          location: helperServices.getFirstLocationNameByLocationId(
            masterLocationDetails,
            invLocationId,
          ),
          locationId: invLocationId,
          taxAmount: `${invoice.taxAmount ? invoice.taxAmount.toFixed(2) : 0}`,
          action: "",
          invoiceLineItems: invoice.invoiceLineItem,
          remarks: invoice.narration,
          isKpCash: invoice.isKpCash,
          hmsInvoiceType: invoice.isKpCash ==null? "" : invoice.isKpCash ? INVOICE_DETAILS_LABEL.KPCASH : INVOICE_DETAILS_LABEL.KPCREDIT,
          visitType: invoice.patientERPObj?.visitType,
          visitStatus: invoice.patientERPObj?.visitStatus,
          
        };
        uRowData.push(row);
        console.log(`loop data ffjh : ${billAmt} :: ${paymentAmount}`);
        console.log("invDetailInfo : ", invDetailInfo);
        console.log(`fin ${billAmt} : ${paymentAmount}`);
      } catch (error) {
        console.log("Error while looping the invoice list", error);
      }
    });
  }
  // Accumulate for 'all'
  finInvSummary.all.totalReceivedAmount += calculatedTotalAdvPaid;
  finInvSummary.all.totalRoundOffAmt += calTotalRoundOffAmt;
  finInvSummary.all.totalDiscountAmount += calculatedTotalDiscountAmount;
  finInvSummary.all.totalBillAmount += calculatedTotalBillAmt;
  finInvSummary.all.invReceivedAmt += calculatedTotalAdvPaid;
  finInvSummary.all.invPendingPaymentAmt += calTotalInvPendingPaymentAmt;
  finInvSummary.all.totalGrossAmount += calculatedTotalGrossAmount;
  // setTotalFinAmtSummary(finServicesSummary);
  return {
    finSummary: finInvSummary,
    rowData: uRowData,
  };
}

function getAllRowDataSaleOrders(
  serviceList,
  uRowData,
  finServicesSummary,
  masterLocationDetails,
) {
  if (!finServicesSummary) finServicesSummary = {};
  if (!finServicesSummary.all) {
    finServicesSummary.all = {
      totalReceivedAmount: 0,
      totalBillAmount: 0,
      totalDiscountAmount: 0,
      totalGrossAmount: 0,
      invReceivedAmt: 0,
      invPendingPaymentAmt: 0,
      totalSalesOrderAmt: 0,
      totalReceivedAdvanceAmt: 0,
      creditBalance: 0,
      totalRoundOffAmount: 0,
      creditInvoiceCount: 0,
    };
  }
  if (serviceList != null) {
    serviceList.forEach((service) => {
      console.log("service : ", service);
      const salesOrderLineItems = service.salesOrderLineItems;
      let salesOrderDate = "";
      let serviceUpdateDate = "";
      let totalServiceAmount = 0;
      let totalReceivedAmount = 0;
      let calculatedTotalDiscountAmount = 0; // Create a local variable to track total discount paid
      let calculatedTotalGrossAmount = 0; // Create a local variable to track total discount paid
      salesOrderLineItems.forEach((salesOrderLineItem) => {
        salesOrderDate = new Date(salesOrderLineItem.salesOrderDate);
        let serviceLocationId = salesOrderLineItem.location;
        if (!(serviceLocationId in finServicesSummary)) {
          finServicesSummary[serviceLocationId] = {
            totalReceivedAmount: 0,
            totalBillAmount: 0,
            totalDiscountAmount: 0,
            totalGrossAmount: 0,
            invReceivedAmt: 0,
            invPendingPaymentAmt: 0,
            totalSalesOrderAmt: 0,
            totalReceivedAdvanceAmt: 0,
            creditBalance: 0,
            totalRoundOffAmount: 0,
          };
        }
        let quantity = salesOrderLineItem.units;
        let amount = quantity * salesOrderLineItem.price;
        let originalAmount = quantity * salesOrderLineItem.originalPrice;
        calculatedTotalDiscountAmount = originalAmount - amount;
        // Accumulate for location
        finServicesSummary[serviceLocationId].totalGrossAmount +=
          originalAmount;
        finServicesSummary[serviceLocationId].totalBillAmount += amount;
        finServicesSummary[serviceLocationId].totalSalesOrderAmt += amount;
        finServicesSummary[serviceLocationId].totalDiscountAmount +=
          originalAmount - amount;
        totalServiceAmount += amount;
        // Accumulate for 'all'
        finServicesSummary.all.totalBillAmount += amount;
        finServicesSummary.all.totalGrossAmount += originalAmount;
        finServicesSummary.all.totalDiscountAmount +=
          calculatedTotalDiscountAmount;
        finServicesSummary.all.totalSalesOrderAmt += amount;
        // setTotalFinAmtSummary(finServicesSummary);
        serviceUpdateDate = `${salesOrderDate.getDate()} ${
          MONTH_SHORT_NAME[salesOrderDate.getMonth()]
        } ${salesOrderDate.getFullYear()}`;
      });
      let ticketId = service.ticketId;
      let serviceType = ERP_VISIT_FIN_SUMMARY_TYPE_SO;
      let location = service.location;
      let action = "";

      let row = {
        soId: ticketId,
        type: serviceType,
        invoiceDate: serviceUpdateDate,
        billAmt: `₹ ${totalServiceAmount}`,
        paymentAmt: `₹ ${totalServiceAmount}`, //invoice.productName,
        location: helperServices.getFirstLocationNameByLocationId(
          masterLocationDetails,
          location,
        ), //description: service.productName,
        locationId: location,
        hmsInvoiceType: "",
        generatedBy: service.userDisplayName,
        action: "",
        serviceDetails: service,
      };
      // uRowData.push(row);
      console.log("salesOrder : ", service);
    });
  }
  return {
    finSummary: finServicesSummary,
    rowData: uRowData,
  };
}

function getAllPatientPayments(
  customerPaymentInfo,
  uRowData,
  finPaymentsSummary,
  masterLocationDetails,
  org,
) {
  if (!finPaymentsSummary) finPaymentsSummary = {};
  if (!finPaymentsSummary.all) {
    finPaymentsSummary.all = {
      totalReceivedAmount: 0,
      totalBillAmount: 0,
      totalGrossAmount: 0,
      invReceivedAmt: 0,
      invPendingPaymentAmt: 0,
      totalSalesOrderAmt: 0,
      totalReceivedAdvanceAmt: 0,
      creditBalance: 0,
      totalRoundOffAmount: 0,
      creditInvoiceCount: 0,
    };
  }
  if (customerPaymentInfo) {
    customerPaymentInfo.forEach((payment) => {
      const date = new Date(payment.paymentDate);
      let paymentDate = `${date.getDate()} ${
        MONTH_SHORT_NAME[date.getMonth()]
      } ${date.getFullYear()}`;
      let paymentLocationId = payment.locationId ? payment.locationId : 0;
      if (
        paymentLocationId == "undefined" ||
        !(paymentLocationId in finPaymentsSummary)
      ) {
        finPaymentsSummary[paymentLocationId] = {
          totalReceivedAmount: 0,
          totalBillAmount: 0,
          totalGrossAmount: 0,
          invReceivedAmt: 0,
          invPendingPaymentAmt: 0,
          totalSalesOrderAmt: 0,
          totalReceivedAdvanceAmt: 0,
          creditBalance: 0,
          totalRoundOffAmount: 0,
        };
      }
      // Accumulate for location
      finPaymentsSummary[paymentLocationId].totalReceivedAmount +=
        payment.balanceAmount;
      finPaymentsSummary[paymentLocationId].totalReceivedAdvanceAmt +=
        payment.receivedAmount;
      finPaymentsSummary[paymentLocationId].creditBalance +=
        payment.balanceAmount;
      // Accumulate for 'all'
      finPaymentsSummary.all.totalReceivedAmount += payment.balanceAmount;
      finPaymentsSummary.all.totalReceivedAdvanceAmt += payment.receivedAmount;
      finPaymentsSummary.all.creditBalance += payment.balanceAmount;

      console.log("service total amount: ", org, org?.orgCode);
      if (org?.orgCode.toLowerCase() === "manaswini") {
        payment.voucherNumber = payment.voucherId;
      }
      let row = {
        invoiceId: payment.voucherNumber,
        voucherId: payment?.voucherId,
        type:
          payment.receivedAmount < 0
            ? ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS
            : ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS,
        patientId: payment.patientId,
        visitId: payment?.patientERPObj?.visitId,
        ipopnumber: payment?.patientERPObj?.ipopnumber,
        patientFullName: payment.patientFullName,
        invoiceDate: paymentDate,
        receivedAmt: `₹ ${payment.receivedAmount}`,
        paymentAmt: "₹ 0",
        location: helperServices.getFirstLocationNameByLocationId(
          masterLocationDetails,
          paymentLocationId,
        ),
        locationId: paymentLocationId,
        hmsInvoiceType: "",
        paymentDetails: payment,
        generatedBy: payment?.userDisplayName || "",
        
        action: "",
      };
      uRowData.push(row);
    });
    return {
      finSummary: finPaymentsSummary,
      rowData: uRowData,
    };
  }
}

